import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, Eye, Lock, Lightbulb, Server } from 'lucide-react';

const usps = [
  {
    icon: Lightbulb,
    title: 'First of its kind',
    description: 'No existing solution combines QR payments, SWIFT/SEPA, and cross-border transfers in a single unified wallet. We built what the market was missing.',
  },
  {
    icon: ShieldCheck,
    title: 'Security by design',
    description: 'End-to-end encryption, multi-factor authentication, and real-time fraud monitoring. Your funds and data are protected by enterprise-grade security.',
  },
  {
    icon: Zap,
    title: 'Instant settlement',
    description: 'Our proprietary settlement engine processes transactions in near real-time, eliminating days-long waiting periods typical of legacy systems.',
  },
  {
    icon: Eye,
    title: 'Full transparency',
    description: 'See every fee, every exchange rate, every step of your transaction. No hidden charges, no surprises — just complete visibility.',
  },
  {
    icon: Lock,
    title: 'Compliance-first approach',
    description: 'Built to meet international regulatory requirements from day one. Licensed and compliant with financial regulations across our operational markets.',
  },
  {
    icon: Server,
    title: 'Partner-ready architecture',
    description: 'Our open API framework enables seamless integration with banks, fintechs, and enterprise platforms. Built for the ecosystem, not just end users.',
  },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
};

export const Innovation = () => {
  return (
    <section
      id="innovation"
      className="ink-section circuit-pattern-dark py-16 sm:py-20"
      data-testid="innovation-section"
    >
      <div className="container-main">
        <div className="text-center mb-12">
          <p className="font-mono-accent text-xs font-medium uppercase tracking-[0.18em] text-[#A78BFA] mb-3">
            Why TexSolution
          </p>
          <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-white mb-4">
            The innovation the market has been waiting for
          </h2>
          <p className="text-base text-[#A78BFA] max-w-2xl mx-auto leading-relaxed">
            There is no solution like TexSolution on the market today. We've built the technology that allows our clients to feel safer, more confident, and more in control of their global finances.
          </p>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {usps.map((usp, index) => (
            <motion.div key={index} variants={cardVariants}>
              <div
                className="rounded-2xl p-6 sm:p-7 h-full transition-colors duration-200 hover:border-[#7C3AED]"
                style={{ background: '#12121A', border: '1px solid #2A2A36' }}
              >
                <div className="h-10 w-10 rounded-xl flex items-center justify-center mb-4" style={{ background: 'rgba(124,58,237,0.15)' }}>
                  <usp.icon className="h-5 w-5 text-[#A78BFA]" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">{usp.title}</h3>
                <p className="text-sm text-[#A0A0B0] leading-relaxed">{usp.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
